import DriverColumnCard from "../components/DriverColumnCard";
import DriverRouteCard from "../components/DriverRouteCard";
import reportConstants from "../constants";
const ganttConfig = {
  columns: [
    {
      name: "external",
      label: "",
      align: "center",
      onrender: (item) => {
        return item.type === "project" ? (
          <DriverColumnCard data={item} />
        ) : (
          <DriverRouteCard data={item} />
        );
      },
    },
  ],
  scale_height: 62,
  min_column_width: 125,
  row_height: 40,
  bar_height: 37,
  grid_elastic_columns: true,
  initial_scroll: false,
};

const getGanttTemplates = () => ({
  grid_row_class: (start, end, task) => {
    if (task.isDriverDelayed) return "delayedRow";
  },
  task_row_class: (start, end, task) => {
    const rowClassList = [];
    if (task.isDriverDelayed) rowClassList.push("delayedRow");
    if (task.isLastRow) rowClassList.push("lastRow");
    return rowClassList.join(" ");
  },
  task_class: (start, end, task) => {
    let classList = [];
    classList.push(task.type);
    if (task.isCurrentStop) {
      classList.push("currentStop");
    }
    return classList.join(" ");
  },
  rightside_text: (start, end, task) => {
    if (
      [
        reportConstants.REPORT_STOP_TYPES.trailerDrop,
        reportConstants.REPORT_STOP_TYPES.trailerHook,
      ].includes(task.type)
    ) {
      return `Trailer ${task.routeData.trailerNumber}`;
    }
  },
});

const getGanttLayout = () => ({
  css: "gantt_container",
  cols: [
    {
      width: 290,
      min_width: 250,
      rows: [
        {
          view: "grid",
          scrollY: "scrollVer",
          config: ganttConfig,
          templates: getGanttTemplates(),
        },
      ],
    },
    { resizer: true, width: 0 },
    {
      rows: [
        {
          view: "timeline",
          scrollX: "scrollHor",
          scrollY: "scrollVer",
          config: ganttConfig,
          templates: getGanttTemplates(),
        },
        { view: "scrollbar", id: "scrollHor", group: "horizontal" },
      ],
    },
    { view: "scrollbar", id: "scrollVer" },
  ],
});

const getGanttZoomConfig = () => {
  return reportConstants.DEFAULT_SCALE_LEVELS.map((scaleOption) => [
    {
      unit: scaleOption.unit,
      format: "%H:%i",
      step: scaleOption.value,
    },
  ]);
};

export { getGanttLayout, getGanttZoomConfig };
